import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Home from './Components/Home/Home';
import Searchtransporters from './Components/Searchtransporters';
// import Covid19ImpactReport from './Components/Covid19ImpactReport/Covid19ImpactReport';
// import CoronaInformationDashboard from './Components/CoronaInformationDashboard/CoronaInformationDashboard';
import NotFound from './Components/NotFound/NotFound';
import GlobalGrid from './Components/GlobalGrid/GlobalGrid';

const RouterOutlet = () => {
  return (
    <Switch>
      <Route path="/Home" component={Home} exact />
      <Route path="/" component={Home} exact />
      <Route path="/searchtransporters" component={Searchtransporters} exact />
      {/* <Route path="/Covid19ImpactReport" component={Covid19ImpactReport} exact /> */}
      {/* <Route path="/CoronaInformationDashboard" component={CoronaInformationDashboard} exact /> */}
      <Route path="/grid" component={GlobalGrid} exact />
      <Route component={NotFound} />
    </Switch>
  );
};

export default RouterOutlet;
